import React from "react";
import "./styles.css";

const PagesHeadLine = ({ content }) => (
  <div className="pages-headline-container">
    <span className="pages-headline-content">{content}</span>
  </div>
);

export default PagesHeadLine;
